import React from "react";
import withStyles from '@mui/styles/withStyles';


import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


import Button from '@mui/material/Button';


const styles = theme => ({

    dialogContent: {
        display: 'flex',
        flexDirection: 'column'
    }

});

const DeleteFraisRetourExcluDialog = ({ classes, onClose, onClickDelete, fraisRetourExclu, niveaux }) => {
       
    const remove = () => {
        onClickDelete(fraisRetourExclu.id);
    };

    let niveau = niveaux.find(n => n.id === fraisRetourExclu.niveau);

    return (
        <Dialog open>
            <DialogTitle>Suppression d'une exclusion pour les frais de retour</DialogTitle>

            <DialogContent className={classes.dialogContent}>

                <p>Êtes-vous sûr de vouloir supprimer l'exclusion pour le niveau <strong>{niveau.libelle}</strong> avec le code <strong>{fraisRetourExclu.code}</strong> et le profil PO <strong>({fraisRetourExclu.profilPO})</strong> ?</p>


            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    color="primary"
                >
                    Annuler
                </Button>
                <Button
                    onClick={remove}
                    variant="contained"
                    color="secondary"
                >
                    Supprimer
                </Button>
            </DialogActions>
        </Dialog>
    );
};


export default withStyles(styles)(DeleteFraisRetourExcluDialog);
